var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSs2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8954_46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 14.3144V21.643C40 22.4001 39.4 23.0001 38.6429 23.0001H32.6857C30.1429 23.0001 28.1 20.9573 28.1 18.4144V17.543C28.1 15.0001 30.1429 12.9573 32.6857 12.9573H38.6429C39.4 12.9573 40 13.5573 40 14.3144Z",
    fill: "#65CDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2429 23.857C15.2429 24.9113 13.8143 25.8356 11.6629 26.3441C10.4929 26.6313 9.10429 26.797 7.61714 26.797C6.14 26.797 4.75143 26.6313 3.58143 26.3441C1.42857 25.8356 0 24.9113 0 23.857C0 22.2298 3.41143 20.907 7.61714 20.907C11.8314 20.9084 15.2429 22.2298 15.2429 23.857Z",
    fill: "#65CDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1571 28.43C10.7943 28.7614 9.21857 28.94 7.61571 28.94C6.02143 28.94 4.44857 28.7614 3.07 28.4257C1.73286 28.11 0.744286 27.6829 0 27.2143V28.84C0 29.8943 1.41857 30.81 3.56 31.3271C4.73 31.6229 6.12857 31.79 7.61571 31.79C9.11286 31.79 10.5014 31.6229 11.6814 31.3271C13.8243 30.81 15.2414 29.8943 15.2414 28.84V27.2114C14.4957 27.6829 13.5014 28.1114 12.1571 28.43Z",
    fill: "#65CDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1857 33.4114C10.83 33.7514 9.24286 33.9328 7.61571 33.9328C5.98286 33.9328 4.4 33.7499 3.03571 33.4056C1.72143 33.0885 0.74 32.6714 0 32.2099V33.8242C0 34.8785 1.41857 35.7942 3.56 36.3199C4.73 36.6071 6.12857 36.7728 7.61571 36.7728C9.11286 36.7728 10.5014 36.6056 11.6814 36.3199C13.8243 35.7928 15.2414 34.8771 15.2414 33.8242V32.2085C14.4986 32.6714 13.5114 33.0914 12.1857 33.4114Z",
    fill: "#65CDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6857 10.8143H38.2714V8.12857C38.2714 5.3 35.9714 3 33.1429 3H8.07144C5.24287 3 2.94287 5.3 2.94287 8.12857V19.3057C4.38573 18.9443 6.00144 18.7657 7.61573 18.7657C12.2386 18.7657 16.9343 20.1643 17.3857 23.3243V28.3529V28.8414V32.9714H33.1429C35.9714 32.9714 38.2714 30.6714 38.2714 27.8429V25.1429H32.6857C28.9757 25.1429 25.9572 22.1243 25.9572 18.4143V17.5429C25.9572 13.8343 28.9757 10.8143 32.6857 10.8143ZM17.2772 10.9771H9.91001C9.20001 10.9771 8.6243 10.4014 8.6243 9.69143C8.6243 8.98143 9.20001 8.40571 9.91001 8.40571H17.2757C17.9857 8.40571 18.5614 8.98143 18.5614 9.69143C18.5614 10.4014 17.9872 10.9771 17.2772 10.9771Z",
    fill: "#65CDBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8954_46"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSs2);
export default __webpack_public_path__ + "static/media/ss2.1e6543140dd434765ae865d12f05f415.svg";
export { ForwardRef as ReactComponent };